<template>
    <SmartLinkItemComponent :id="model.system.id" :component="!model.system.workflow">
        <div :class="getClass()">
            <div :class="`container ${paddingOptions(data.paddingModifications)}`">

                <SmartLinkStandaloneElement :codename="typ.elements.title.codename">
                    <h2 class="title" v-if="data.title">
                        {{ data.title }}
                    </h2>
                </SmartLinkStandaloneElement>
                <SmartLinkStandaloneElement :codename="typ.elements.title.codename">
                    <div class="content">
                        <RichText :value="data.content" />
                    </div>
                </SmartLinkStandaloneElement>
                <form class="form-contact">
                    <div class="row">
                        <!-- Left Col -->
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label class="form-label" for="name">Name</label>
                                <input class="form-control" type="text" placeholder="Enter claimant's name" />
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="address">Address</label>
                                <input class="form-control" type="text" placeholder="Enter current address" />
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="city">City</label>
                                <input class="form-control" type="text" placeholder="Enter city" />
                            </div>
                            <div class="row">
                                <div class="col-lg-7">
                                    <div class="form-group">
                                        <label class="form-label" for="State">State</label>
                                        <select class="form-select">
                                            <option selected>Select State</option>
                                            <option value="california">California</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-5">
                                    <div class="form-group">
                                        <label class="form-label" for="zip-code">Zip Code</label>
                                        <input class="form-control" type="text" placeholder="Zip Code" />
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="phone-number">Phone Number</label>
                                <input class="form-control" type="tel" placeholder="Enter Phone Number" />
                            </div>
                        </div>
                        <!-- Right Col -->
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label class="form-label" for="email-address">Email Address</label>
                                <input class="form-control" type="email" placeholder="Enter email address" />
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="reason-for-contact">Reason For Contact</label>
                                <select class="form-select">
                                    <option selected>Select Reason</option>
                                    <option value="reason-1">Reason 1</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="questions-comment">Question/Comment</label>
                                <textarea class="form-control" placeholder="Enter your question or comment here..."
                                    rows="10"></textarea>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

        </div>
    </SmartLinkItemComponent>
</template>

<script setup lang="ts">
import type { ContactFormModel } from '~/models';
import { contentTypes } from '~/models';
import { paddingOptions } from '~/utils/styling-options'

const typ = contentTypes.contact_form;
const props = defineProps<{ model: ContactFormModel }>();

const data = {
    title: props.model.elements.title.value,
    content: props.model.elements.content.value,
    paddingModifications: props.model.elements.paddingModificationsPaddingModifications.value.map((item) => item.codename),
  background: firstOrDefault(props.model.elements.background.value),
    addressChangeOption: firstOrDefault(props.model.elements.addressChangeOption.value)
}

function getClass() {
    let cls = `contact-form`;

    if (data.background) {
        cls = `${cls} ${backgroundOptions(data.background.codename)}`
    }

    return cls;
}
</script>
